import { fetchWrapperPortal } from './fetch';

export interface Theme {
  _id?: string;
  subdomain?: string;
  primaryColor?: string;
  secondaryColor?: string;
  logo?: string;
  [key: string]: any;
}

export const createTheme = async (themeData: Partial<Theme>): Promise<Theme> => {
  return await fetchWrapperPortal<Theme>({
    url: 'admin/themes',
    method: 'POST',
    headers: {
      'x-internal-secret': import.meta.env.VITE_INTERNAL_SECRET,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(themeData),
    addBearer: true,
  });
};

export const getThemes = async (query: Record<string, any> = {}): Promise<Theme[]> => {
  const queryString = new URLSearchParams(query).toString();
  return await fetchWrapperPortal<Theme[]>({
    url: `admin/themes${queryString ? `?${queryString}` : ''}`,
    method: 'GET',
    headers: {
      'x-internal-secret': import.meta.env.VITE_INTERNAL_SECRET,
    },
    addBearer: true,
  });
};

export const getThemeBySubdomain = async (subdomain: string): Promise<Theme> => {
  return await fetchWrapperPortal<Theme>({
    url: `admin/themes/${subdomain}`,
    method: 'GET',
    headers: {
      'x-internal-secret': import.meta.env.VITE_INTERNAL_SECRET,
    },
    addBearer: true,
  });
};

export const updateTheme = async (themeId: string, themeData: Partial<Theme>): Promise<Theme> => {
  return await fetchWrapperPortal<Theme>({
    url: `admin/themes/${themeId}`,
    method: 'PUT',
    headers: {
      'x-internal-secret': import.meta.env.VITE_INTERNAL_SECRET,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(themeData),
    addBearer: true,
  });
};

export const deleteTheme = async (themeId: string): Promise<any> => {
  return await fetchWrapperPortal({
    url: `admin/themes/${themeId}`,
    method: 'DELETE',
    headers: {
      'x-internal-secret': import.meta.env.VITE_INTERNAL_SECRET,
    },
    addBearer: true,
  });
};
